import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {CustomerInteractionService} from "../../../service/api/customer-interaction.service";
import {CustomerInteractionDto} from "../../../model/dto/entity/customer-interaction.dto";
import {MvsObjectNavigationService} from "../../../../../core/shared/navigation/mvs-object-navigation.service";
import {ObjectIdentifier} from "../../../../../core/shared/basic/object-identifier";
import {ObjectIdentifierData} from "../../../../../core/shared/basic/object-identifier-data";
import {DtoImportObjectContext} from "../../../../../core/shared/dto/dto.import.object.context";
import {MvsUiObjectService} from "../../../../../core/shared/object/service/mvs-ui-object.service";
import {EntityStatusEnum} from "../../../../../core/shared/entity/enum/entity-status.enum";

@Component({
    selector: 'cr-customer-interaction-inline-component',
    templateUrl: './cr-customer-interaction-inline-component.html',
    standalone: false
})
export class CrCustomerInteractionInlineComponent implements OnInit, OnChanges {

    @Output() onObjectSelect = new EventEmitter<ObjectIdentifier | ObjectIdentifierData>();
    @Input() objectIdentifier: ObjectIdentifier;
    @Input() importObjectContext: DtoImportObjectContext;
    @Input() size: string = 'M';
    icon: string;
    dto: CustomerInteractionDto;

    protected readonly EntityStatusEnum = EntityStatusEnum;
    initialized: boolean;
    busy: boolean;

    constructor(protected customerInteractionService: CustomerInteractionService,
                protected navigationService: MvsObjectNavigationService,
                protected objectService: MvsUiObjectService
                ) {
    }

    ngOnInit() {
        this.initComponent();
    }

    initComponent() {
        this.icon = this.customerInteractionService.getObjectIcon();
        this.refreshComponent();

    }

    refreshComponent() {
        this.customerInteractionService.get(this.objectIdentifier?.objectId).subscribe((res: CustomerInteractionDto) => {
            this.dto = res;
            this.initialized = true;
        });
    }
    handleClick() {
        this.onObjectSelect.emit(this.objectIdentifier);
        // const mvsObjectNavigationEntry = MvsObjectNavigationEntry.createNavigationEntry(this.objectIdentifier.objectType, this.objectIdentifier.objectId, null, this.objectIdentifier.objectType, null, null, MvsObjectNavigationActionEnum.any);
        // this.navigationService.navigateTo(mvsObjectNavigationEntry, 'left');
        // this.objectService.openObjectViaDialog(
        //     null,
        //     this.objectIdentifier.objectType,
        //     this.objectIdentifier.objectId,
        //     null,
        //     false,
        //     false,
        //     () => {
        //         //
        //     },
        //     MvsCrudModeEnum.update
        // );
        // const navigationEntry = MvsObjectNavigationEntry.createNavigationEntry(this.objectIdentifier.objectType, this.objectIdentifier.objectId, null, this.objectIdentifier.objectType, null, null, MvsObjectNavigationActionEnum.any);
        // this.navigationService.addOverlay(navigationEntry);
    }

    ngOnChanges(changes: SimpleChanges) {

    }
}
